module.exports = __webpack_public_path__ + "img/product-preview-41.0b70acc.png";